import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { getBankInformationRes } from "core/http/service/personnelInformation/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: getBankInformationRes;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: { accountBankCode: "", bankName: "" },
};

const getBankInformationSlice = createSlice({
  name: "getBankInformation",
  initialState,
  reducers: {
    getBankInformationStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getBankInformationSuccess: (
      state,
      action: PayloadAction<getBankInformationRes>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getBankInformationFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetBankInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  getBankInformationStart,
  getBankInformationSuccess,
  getBankInformationFailed,
  resetBankInformation,
} = getBankInformationSlice.actions;

export default getBankInformationSlice.reducer;
